import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { getactionMessages } from '../../constants/messages';
import AddProductForm from './AddProductForm';

let messages = getactionMessages();

const AddProductButton = () => {
	const [showModal, setShowModal] = useState(false);

	return (
		<span>
			<Button
				className="editable-add-btn"
				type="primary"
				icon={<PlusOutlined />}
				onClick={() => setShowModal(true)}
			>
				<FormattedMessage {...messages.add} />
			</Button>
			<AddProductForm showModal={showModal} handleCancel={() => setShowModal(false)} />
		</span>
	);
};

export default AddProductButton;
